<template>
  <div>
    <section class="index-header p-b-15 m-b-15">
      <div class="level index-actions">
        <div class="level-left">
          <div class="level-item">
            <h1>Contacts</h1>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a class="button is-primary is-inverted" @click="close">Back to Contacts</a>
          </div>
        </div>
      </div>
    </section>
    <div class="content single">
      <div class="level page-actions is-marginless p-b-30 is-mobile">
        <div class="level-left">
          <div class="level-item m-r-30">
            <h3 class="m-b-30">{{ contact.full_name }}</h3>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <ContactEditButton :contact="contact" v-if="$can.includes('update-contacts')"/>
          </div>
        </div>
      </div>
      <section class="section is-paddingless">
        <div class="columns is-marginless">
          <aside class="column is-3 is-paddingless">
            <div class="aside-inner">
              <section class="m-b-30 single-aside-details--data">
                <fieldset>
                  <div class="field" v-if="$can.includes('view contact info')">
                    <label class="label">Mobile Phone</label>
                    <p>{{ contact | orBlank('mobile_phone') }}</p>
                  </div>
                  <div class="field" v-if="$can.includes('view contact info')">
                    <label class="label">Office Phone</label>
                    <p>{{ contact | orBlank('office_phone') }}</p>
                  </div>
                  <div class="field" v-if="$can.includes('view contact info')">
                    <label class="label" >Email</label>
                    <p>{{ contact | orBlank('email') }}</p>
                  </div>
                  <div class="field">
                    <label class="label">Website</label>
                    <p>
                      <a
                        v-if="contact.website"
                        v-bind:href="contact.website"
                        target="_blank"
                      >{{ contact.website }}</a>
                      <span v-else>...</span>
                    </p>
                  </div>
                  <div class="field">
                    <label class="label">Company</label>
                    <p>{{ contact | orBlank('company_name') }}</p>
                  </div>
                  <div class="field">
                    <label class="label">Type</label>
                    <p>{{ contact.type | orBlank('name') }}</p>
                  </div>
                  <div class="field">
                    <label class="label">Title</label>
                    <p>{{ contact | orBlank('title') }}</p>
                  </div>
                  <div class="field" v-if="$can.includes('view contact info')">
                    <label class="label">Location</label>
                    <p>
                      <span v-if="contact.address_line1">
                        {{ contact.address_line1 }}
                        <br>
                      </span>
                      <span v-if="contact.address_line2">
                        {{ contact.address_line2 }}
                        <br>
                      </span>
                      <span v-if="contact.address_city">{{ contact.address_city }},</span>
                      <span v-if="contact.address_state">{{ contact.address_state }}</span>
                      <span class="m-l-5" v-if="contact.address_zip">{{ contact.address_zip }}</span>
                      <br>
                      {{ contact.address_country }}
                    </p>
                  </div>
                </fieldset>
              </section>
              <section class="m-b-30 single-aside-details--tags">
                <label class="label">Tags</label>
                <tag-control taggableType="contact" :taggableId="contact.id" />
              </section>
            </div>
          </aside>
          <div class="column is-9 is-paddingless">
            <note-control :notableId="contact.id" notableType="contact"></note-control>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import { CONTACT_READ } from '@/store/actions'
import store from '@/store'

import ContactEditButton from '@/components/ContactEditButton'

export default {
  name: 'ContactShow',
  components: {
    ContactEditButton
  },
  props: {
    propped: Object
  },

  data() {
    return {
      contact: null
    }
  },

  created() {
    this.contact = Object.assign({}, this.model)
  },

  computed: {
    model: function () {
      if (this.$store.state.contact.contact.id) return Object.assign({}, this.$store.state.contact.contact)
      if (this.propped) return Object.assign({}, this.propped)

      return {}
    }
  },

  watch: {
    model: function (newValue, oldValue) {
      this.contact = Object.assign({}, newValue)
    }
  },

  beforeRouteEnter: function (to, from, next) {
    store.dispatch(CONTACT_READ, to.params.id)
    next()
  },

  beforeRouteUpdate: function (to, from, next) {
    store.dispatch(CONTACT_READ, to.params.id)
    next()
  },

  methods: {
    close() {
      this.$router.push({ name: 'contacts.index' })
    }
  }
}
</script>
